import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IIconSwitchOption } from '../../../core/interfaces/IIconSwitchOption';

@Component({
  selector: 'app-icon-switch',
  standalone: true,
  imports: [],
  templateUrl: './icon-switch.component.html',
  styleUrl: './icon-switch.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconSwitchComponent<T extends string = string> {

  @Input({ required: true }) options: IIconSwitchOption<T>[];
  @Input({ required: true }) selectedValue: T;

  @Output() selectedValueChange = new EventEmitter<T>();

  public select(value: T): void {
    if (this.selectedValue === value) {
      return;
    }

    this.selectedValueChange.emit(value);
  }
}
